/**
 * Compras copy (`en`): tall «estats» de les millores de Compres (OBR-190 / OBR-181 / OBR-117). Tall propi: no es toca `en.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 *
 * OBR-190, «Pending dispatch» purchase-order status: the status labels live in
 * `backoffice.purchaseOrderStatus` (in `en.ts`); the NEW texts that go with it are here.
 */

export const estatsEn = {
  'backoffice.purchaseOrderDispatch': {
    receptionBlockedHint:
      'You have not sent this order to the supplier yet. Send it or mark it as sent before registering its reception.',
    draftNotVisibleToPlanta:
      'This order is still a draft and does not show in the planta app reception. Confirm it and send it to the supplier so the operator can receive it.',
    pendingNotVisibleToPlanta:
      'This order is confirmed but has not been sent to the supplier yet, so it does not show in the planta app reception and cannot be received. Send it or mark it as sent.',
    // El formulari d'edició d'una comanda que ja no és un esborrany (enllaç directe: el detall n'amaga el botó).
    notEditable:
      'This order can no longer be edited: only orders in progress (drafts) can be changed.',
    skip_not_sent_one: '{{count}} has not been sent to the supplier yet (if it is no longer needed, it is cancelled)',
    skip_not_sent_other: '{{count}} have not been sent to the supplier yet (if they are no longer needed, they are cancelled)',
  },
} as const;
